<div class="container">
    <div class="blockMovie">
        <a class="btn addMovie" [routerLink]="['add-movie']" >Add Movie</a>
        <a class="btn randMovie" (click)="randomMovie()">Random Movie</a>
        <a class="btn" [routerLink]="['']">Return List Movies</a>
    </div>
    <div class="listMovie">
        <span class="contentList">List to watch : </span>
        <ul>
            <li class="movies" *ngFor="let movies of listMovie"> {{ movies }} 
                <span id="id_{{ movies }}">
                    <a class="editMovie" (click)="editMovie(movies)"><i class="fas fa-pencil-alt"></i></a> 
                    <a class="deleteMovie" (click)="deleteMovie(movies)"><i class="fas fa-trash"></i></a>
                </span> 
            </li>
        </ul>
    </div>
    <!-- <Playlist></Playlist> -->
</div>
